import React from "react";
import './_static/Buttons.css';

function NextPage(props) {

    function navigateNextPage() {
        props.changePage()
    }

    return (
        // <div className="mb-3">
                <button type="button" className="btn btn-outline-primary btn-md bigButton" style={{"opacity": "0.8"}} onClick={navigateNextPage}>
                    Ďalšie<svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                    </svg>
                </button >
        // </div>
    )
}

export default NextPage
